<template>
  <el-main class="page-content-margin-unset">
    <div class="dk-li">
      <h3
        style="display:inline-block">订单信息</h3>
      <el-button
        type="warning"
        v-if="status == '待支付'"
        @click="event().onChangMoneyClick()">
        修改实际支付金额
      </el-button>
    </div>
    <el-table
      border
      :data="body">
      <el-table-column
        prop="order_id"
        label="订单号"/>
      <el-table-column
        prop="create_time"
        label="创建时间"/>
      <el-table-column
        prop="nickname"
        label="用户昵称"/>
      <el-table-column
        prop="mobile"
        label="手机号"/>
      <el-table-column
        prop="money"
        label="订单金额"/>
      <el-table-column
        prop="paid_money"
        label="实际支付金额€"/>
      <el-table-column
        prop="pay_rmb"
        label="实际支付金额￥"/>
      <el-table-column
        prop="exchange_rate"
        label="支付时汇率"/>
      <el-table-column
        prop="pay_type"
        label="支付方式">
        <template slot-scope="scope">
          <span>{{ ['','微信','支付宝','线下'][scope.row.pay_type] }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="pay_time"
        label="支付时间"/>
      <el-table-column
        prop="status"
        label="订单状态"/>
      <el-table-column
        prop="cash"
        label="积分抵扣"/>
      <el-table-column
        prop="invite_code"
        label="推荐人ID"/>
    </el-table>
    <h3>收货地址</h3>
    <el-table
      border
      :data="address">
      <el-table-column
        prop="name"
        label="收货人"/>
      <el-table-column
        prop="mobile"
        label="联系电话"/>
      <el-table-column
        label="收货地址">
        <template slot-scope="scope">
          <span>
            {{ scope.row.province }}
            {{ scope.row.city }}
            {{ scope.row.county }}
            {{ scope.row.detail_address }}
          </span>
        </template>
      </el-table-column>
    </el-table>
    <h3>商品信息</h3>
    <el-table
      border
      :data="product">
      <el-table-column
        label="商品图片">
        <template slot-scope="scope">
          <img
            width="148px"
            :src="imgDomain + scope.row.img_src"
            alt="">
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="product_name"
        label="商品标题"/>
      <el-table-column
        prop="standard_name"
        label="商品规格"/>
      <el-table-column
        prop="quantity"
        label="数量"/>
      <el-table-column
        prop="paid_money"
        label="商品价格"/>
    </el-table>
    <div v-if="status !== '待支付' && status !=='待发货'">
      <h3>物流信息</h3>
      <el-table
        border
        :data="logistics">
        <el-table-column
          prop="logistics_num"
          label="物流单号"/>
        <el-table-column
          prop="delivery_time"
          label="发货时间"/>
        <el-table-column
          prop="origin"
          label="出发地"/>
        <el-table-column
          prop="destination"
          label="目的地"/>
      </el-table>
      <el-table
        border
        :data="logisticsDetail">
        <el-table-column
          prop="time"
          label="时间"/>
        <el-table-column
          prop="address"
          label="当前状态"/>
      </el-table>
    </div>

    <!-- 修改实际金额 -->
    <el-dialog
      width="480px"
      title="修改金额"
      :visible.sync="changeMoneyDialog">
      <el-form
        :model="changeMoneyBody"
        label-position="left"
        :rules="rules3"
        ref="ruleForm3"
        label-width="120px"
        class="demo-ruleForm">
        <el-form-item
          label="实际支付金额："
          prop="paid_money">
          <el-input
            class="dk-input"
            v-model.number="changeMoneyBody.paid_money"/>
        </el-form-item>
      </el-form>
      <div
        slot="footer"
        class="dialog-footer">
        <el-button @click="changeMoneyDialog = false">取 消</el-button>
        <el-button
          type="primary"
          @click="event().onSureChangeMoneyClick('ruleForm3')">确 定</el-button>
      </div>
    </el-dialog>
  </el-main>
</template>

<script>
import { getOrderDetail, chengMoney } from '../../api/order'
import { imgDomain } from '../../configs/env'

export default {
  data() {
    // eslint-disable-next-line
    const checkMoney = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('支付金额不能为空'));
      }
      if (!Number.isInteger(value)) {
        callback(new Error('请输入数字值'));
      } else {
        callback();
      }
    };
    return {
      imgDomain,
      conditionTitle: false,
      conditionDialog: true,
      status: '',
      body: [],
      product: [
      ],
      logistics: [
      ],
      logisticsDetail: [],
      address: [],
      // 修改待支付金额
      changeMoneyDialog: false,
      changeMoneyBody: {
        paid_money: '',
      },
      rules3: {
        paid_money: [
          { validator: checkMoney, trigger: 'blur' },
        ],
      },
    };
  },
  created() {
    this.network().getOrderDetail()
  },
  methods: {
    event() {
      return {
        onChangMoneyClick: () => {
          this.changeMoneyBody.paid_money = this.body[0].paid_money
          this.changeMoneyBody.uuid = this.body[0].order_uuid
          this.changeMoneyDialog = true
        },
        onSureChangeMoneyClick: (formName) => {
          this.$refs[formName].validate((valid) => {
            if (valid) {
              this.network().chengMoney()
            } else {
              console.log('error submit!!');
            }
          });
        },
      }
    },
    network() {
      return {
        getOrderDetail: async () => {
          const { status, data } = await getOrderDetail(this.$route.query.uuid)
          if (status !== 200) return
          this.body = [data]
          this.status = data.status
          this.product = data.product
          this.address = [data.address]
          this.logisticsDetail = data.logistics_detail
          this.logistics = [data.logistics]
        },
        chengMoney: async () => {
          const { status } = await chengMoney(this.changeMoneyBody)
          if (status !== 200) return
          this.network().getOrderDetail()
          this.changeMoneyDialog = false
          this.$notify({
            title: '修改成功',
            message: '实际金额修改成功',
            type: 'success',
          });
        },
      }
    },
    handler() {
      return {
      }
    },
  },
  components: {
  },
};
</script>

<style scoped lang="scss">
@import '../../assets/styles/mixins.scss';
.page-content-margin-unset{
  .dk-from{
    display: flex;
  }
  .table-top{
    @include dk-table-top;
  }
}
</style>



// WEBPACK FOOTER //
// src/vuepage/user/feedback-detail.vue